import { createSlice } from '@reduxjs/toolkit';
import { revertAll } from '../actions';

export interface INotificationsState {
    count: number;
    clearedAll: boolean;
    totalNotificationsCount: number;
    isShowNotificationSettingPopup: boolean;
    show_notifications: boolean;
    allow_notifications: boolean;
    showPopUpPosition: null | HTMLElement;
}

const initialState: INotificationsState = {
    count: 0,
    clearedAll: false,
    totalNotificationsCount: 0,
    isShowNotificationSettingPopup: false,
    showPopUpPosition: null,
    show_notifications: false,
    allow_notifications: false,
};

const notificationsSlice = createSlice({
    name: 'heater',
    initialState,
    reducers: {
        setUnreadNotificationsCount: (state, action) => {
            return {
                ...state,
                count: action.payload,
            };
        },
        setAllNotificationsCleared: (state, action) => {
            return {
                ...state,
                clearedAll: action.payload,
            };
        },
        setAllNotificationsCount: (state, action) => {
            return {
                ...state,
                totalNotificationsCount: action.payload,
            };
        },
        showNotificationSettingPopUp: state => {
            return {
                ...state,
                isShowNotificationSettingPopup: true,
            };
        },
        hideNotificationSettingPopUp: state => {
            return {
                ...state,
                isShowNotificationSettingPopup: false,
            };
        },
        updateNotificationSetting: (state, action) => {
            return {
                ...state,
                ...action?.payload,
            };
        },
        updateNotificationPopUpPotion: (state, action) => {
            return {
                ...state,
                showPopUpPosition: action?.payload,
            };
        },
    },
    extraReducers: builder => builder.addCase(revertAll, () => initialState),
});

export const {
    setUnreadNotificationsCount,
    setAllNotificationsCleared,
    setAllNotificationsCount,
    showNotificationSettingPopUp,
    hideNotificationSettingPopUp,
    updateNotificationSetting,
    updateNotificationPopUpPotion,
} = notificationsSlice.actions;

export const notificationsReducer = notificationsSlice.reducer;
